import { Check } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/atoms/card";
import { useTranslation } from "react-i18next";

export const CompletionStep = () => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <span>{t("sharepoint.completion.header")}</span>
        </CardTitle>
        <CardDescription>{t("sharepoint.completion.subtitle")}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="py-8 text-center">
          <Check className="mx-auto mb-4 h-16 w-16 text-green-500" />
          <h3 className="mb-2 text-xl font-semibold">
            {t("sharepoint.completion.integrationActive")}
          </h3>
        </div>
      </CardContent>
    </Card>
  );
};
